import { SolutionType } from 'src/features/common';

interface IHeadingSet {
  main: string;
  sub: string;
}

export const getChooseSolutionHeadings = (solutionType?: SolutionType, agentJourney?: boolean): IHeadingSet => {
  switch (true) {
    case agentJourney:
      return {
        main: 'Select the solutions best suited for the customers business needs',
        sub: 'Giving you the freedom to choose - Sinawe'
      }
    case SolutionType.thirdPartyOnboarding === solutionType:
      return {
        main: 'Select the solutions best suited for the customer',
        sub: 'Giving you the freedom to choose - Sinawe',
      };
    case SolutionType.buyInStoreFicaOnline === solutionType:
      return {
        main: 'Activate device (s)',
        sub: 'Choose the number of Kwika devices you want to activate',
      };
    default:
      return {
        main: 'Select the solutions best suited for your business needs',
        sub: 'Giving you the freedom to choose - Sinawe',
      };
  }
};
